import {bemClassName} from 'bem-components-connector'

import './style.scss'

export const Checkbox = ({key, id, name, number, label, description, imgUrl, radio = false, mustBeSingle = false, componentName, answersOnQuestions, setAnswersOnQuestions, singleOptions, radioOptions}) => {

    const block = bemClassName('radiobutton-with-img'),
          changeHandler = (e) => {
                let target = e.target,
                    id = target.id

                setAnswersOnQuestions((answersOnQuestionsOld) => {
                    const answersOnQuestionsDraft = {...answersOnQuestionsOld},
                        componentCheckbox = answersOnQuestionsDraft[componentName]

                    if (Array.isArray(componentCheckbox) && componentCheckbox.includes(id)) {
                        const indexForRemove = componentCheckbox.indexOf(target.id)

                        answersOnQuestionsDraft[componentName].splice(indexForRemove, 1)


                    } else {
                        answersOnQuestionsDraft[componentName] = Array.isArray(componentCheckbox) ? [...componentCheckbox, id] : [id]

                        if (singleOptions && Array.isArray(componentCheckbox) && componentCheckbox.length > 0) {


                            singleOptions.forEach((item) => {
                                const singleItemIndex = answersOnQuestionsDraft[componentName].indexOf(item.id)

                                if (singleItemIndex != -1) {
                                    answersOnQuestionsDraft[componentName].splice(singleItemIndex, 1)
                                }

                            })

                        }

                        if (radioOptions && radio && Array.isArray(componentCheckbox) && componentCheckbox.length > 0) {
                            const radioToRemove = radioOptions.map(item => {
                                if (item.id !== id)
                                    return item.id;
                            });

                            answersOnQuestionsDraft[componentName] =
                                answersOnQuestionsDraft[componentName].filter(answer => !radioToRemove.includes(answer))
                        }

                        if (mustBeSingle === true) {
                            answersOnQuestionsDraft[componentName] = [id]
                        }



                    }


                    localStorage.setItem(`${componentName}IsArray`, 'true');
                    localStorage.setItem(componentName, answersOnQuestionsDraft[componentName])

                    return answersOnQuestionsDraft
                })
          },
          isChecked = Array.isArray(answersOnQuestions[componentName]) && answersOnQuestions[componentName].includes(id)



    return (<div className={`choice__act ${block()}`} key={key}>
        <input id={id}
               type={'checkbox'}
               name={name}
               checked={isChecked}
               onChange={changeHandler}
        />
        <label id={id} className={block('label')} >

            <div className={block('text-wrapper')}>
                <p className={block('title')} >
                    {label}
                </p>
                {description ? <p className={block('description')}>{description}</p> : null}
            </div>

            {imgUrl ? <img className={block('illustration')} src={imgUrl} alt="img"/> : null}

        </label>
    </div>)

}